import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { connect } from 'react-redux';

import { errorPageActions } from '../error-page';
import { apiCallFinished } from '../loading-spinner';
import { getDisplayName } from '../../utils';
import { appointmentDraftActions } from '../../api';
import { errorMessagesActions, errorTypes } from '~/components';

export const preloadSteps = (Component) =>
  class extends PureComponent {
    state = {
      isLoading: false,
      isFailed: false,
      isSuccess: false,
    };

    static displayName = `PreloadSteps(${getDisplayName(Component)})`;

    static propTypes = {
      dispatchApiCallFinished: PropTypes.func.isRequired,
      dispatchResetErrorMessagesWith: PropTypes.func.isRequired,
      dispatchSaveDraftAppointmentType: PropTypes.func.isRequired,
      dispatchSetErrorStatus: PropTypes.func.isRequired,

      appointmentType: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),

      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      history: PropTypes.shape({}).isRequired,
      firstPageNotRequiredToken: PropTypes.bool.isRequired,
    };

    static defaultProps = {
      appointmentType: {},
    };

    componentDidMount() {
      const {
        dispatchSaveDraftAppointmentType,
        dispatchApiCallFinished,
        dispatchSetErrorStatus,
        dispatchResetErrorMessagesWith,

        appointmentType,

        location: { search },
        history,
        firstPageNotRequiredToken,
      } = this.props;

      const { appointmentTypeId } = qs.parse(search, { ignoreQueryPrefix: true });

      const isAppointmentTypePersisted = appointmentType.id && appointmentType.name;
      const shouldRestoreAppointmentType =
        appointmentTypeId &&
        (appointmentTypeId !== appointmentType.id || !isAppointmentTypePersisted);

      if (shouldRestoreAppointmentType) {
        dispatchApiCallFinished(false);
        this.setState({ isLoading: true });

        dispatchSaveDraftAppointmentType(appointmentTypeId)
          .then(
            () => {
              this.setState({ isSuccess: true });
            },
            () => {
              this.setState({ isFailed: true });
            },
          )
          .then(() => {
            this.setState({ isLoading: false });
          });
      } else if (isAppointmentTypePersisted) {
        if (!appointmentTypeId) {
          history.replaceWithToken({
            search: `?${qs.stringify({ appointmentTypeId: appointmentType.id })}`,
          });
        }
        this.setState({ isSuccess: true });
      } else if (firstPageNotRequiredToken) {
        dispatchResetErrorMessagesWith([
          { type: errorTypes.INVALID_TOKEN_ERROR_GO_TO_BEGIN_OF_JOURNEY },
        ]);
        dispatchApiCallFinished(true);
      } else {
        dispatchSetErrorStatus(404);
      }
    }

    render() {
      const { isFailed, isSuccess } = this.state;

      if (isSuccess) {
        return <Component {...this.props} />;
      }

      if (isFailed) {
        return <h1>Cannot fetch details</h1>;
      }

      return null;
    }
  };

export const mapStateToProps = ({
  router: { location },
  appointment: {
    draft: { appointmentType },
  },
  services: {
    config: { firstPageNotRequiredToken = false },
  },
}) => ({
  appointmentType,
  location,
  firstPageNotRequiredToken,
});

const mapDispatchToProps = {
  dispatchApiCallFinished: apiCallFinished,
  dispatchSaveDraftAppointmentType: appointmentDraftActions.saveDraftAppointmentType,
  dispatchSetErrorStatus: errorPageActions.setErrorStatus,
  dispatchResetErrorMessagesWith: errorMessagesActions.resetErrorMessagesWith,
};

export const ConnectedPreloadSteps = (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(preloadSteps(Component));
